import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  tableCellClasses,
} from "@mui/material";
import { capitalCase } from "change-case";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { Link } from "react-router-dom";

export default function ParentProposalRecipientsTable({ packageSummary }: { packageSummary: any }) {
  const run = packageSummary?.latestPackageSendRun;
  const rows = run?.recipients ?? packageSummary?.packageChildren ?? [];

  return (
    <MDBox mb={4}>
      <MDTypography variant="h5" mb={3}>
        Sent Companies
      </MDTypography>
      <TableContainer component={Paper}>
        <Table
          size="small"
          sx={{
            [`& .${tableCellClasses.head}`]: {
              backgroundColor: "#666",
              color: "#fff",
            },
            [`& .${tableCellClasses.body}`]: {
              fontSize: 14,
            },
            maxWidth: "100%",
          }}
        >
          <TableHead sx={{ display: "table-header-group" }}>
            <TableRow>
              <TableCell sx={{ width: "18%" }}>Proposal</TableCell>
              <TableCell sx={{ width: "36%" }}>Company</TableCell>
              <TableCell sx={{ width: "24%" }}>Contact</TableCell>
              <TableCell sx={{ width: "12%" }}>Status</TableCell>
              <TableCell align="center" sx={{ width: "10%" }}>
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((child) => (
              <TableRow key={child.id}>
                <TableCell>{child.proposal?.externalIdWithPrefix ?? child.externalIdWithPrefix ?? "-"}</TableCell>
                <TableCell>{child.company?.name ?? "-"}</TableCell>
                <TableCell>
                  {[child.contact?.firstName, child.contact?.lastName].filter(Boolean).join(" ") ||
                    "-"}
                </TableCell>
                <TableCell>
                  {child.status === "PROCESSING"
                    ? "SENDING"
                    : capitalCase(child.proposal?.status ?? child.status)}
                </TableCell>
                <TableCell align="center">
                  <Link to={`/proposals/${child.proposalId ?? child.id}/info`}>Open</Link>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </MDBox>
  );
}
